// extracted by mini-css-extract-plugin
export default {"cardRow":"CardRow_cardRow__WWCkf"};